const pageNameKey = "alarmsNotificationsDrawerModal";

export const alarmsNotificationsDrawerModalEn = {
  [pageNameKey]: {
    title: "Notifications",
    severity: "Severity",
    showAll: "Show all",
    urgentSeverity: "Urgent Severity",
    warningSeverity: "Warning Severity",
    infoSeverity: "Info Severity",
    noNotificationsForSeverity: "No notifications for selected severity.",
    support: "Support",
    idPrefix: "ID",
  },
};

export const alarmsNotificationsDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Notificações",
    severity: "Severidade",
    showAll: "Mostrar tudo",
    urgentSeverity: "Severidade urgente",
    warningSeverity: "Gravidade do aviso",
    infoSeverity: "Severidade da informação",
    noNotificationsForSeverity:
      "Nenhuma notificação para a gravidade selecionada.",
    support: "Suporte",
    idPrefix: "ID",
  },
};

export const alarmsNotificationsDrawerModalDe = {
  [pageNameKey]: {
    title: "Benachrichtigungen",
    severity: "Schweregrad",
    showAll: "Alle anzeigen",
    urgentSeverity: "Kritischer Schweregrad",
    warningSeverity: "Warnungs-Schweregrad",
    infoSeverity: "Info-Schweregrad",
    noNotificationsForSeverity:
      "Keine Benachrichtigungen fur den ausgewahlten Schweregrad.",
    support: "Support",
    idPrefix: "ID",
  },
};

export const alarmsNotificationsDrawerModalZhHans = {
  [pageNameKey]: {
    title: "通知",
    severity: "严重级别",
    showAll: "显示全部",
    urgentSeverity: "紧急级别",
    warningSeverity: "警告级别",
    infoSeverity: "信息级别",
    noNotificationsForSeverity: "所选严重级别暂无通知。",
    support: "支持",
    idPrefix: "ID",
  },
};

export const alarmsNotificationsDrawerModalIt = {
  [pageNameKey]: {
    title: "Notifiche",
    severity: "Gravità",
    showAll: "Mostra tutto",
    urgentSeverity: "Urgente",
    warningSeverity: "Gravità dell'allarme",
    infoSeverity: "Gravità dell'informazione",
    noNotificationsForSeverity: "Nessuna notifica per la gravità selezionata.",
    support: "Supporto",
    idPrefix: "ID",
  },
};

export const alarmsNotificationsDrawerModalEs = {
  [pageNameKey]: {
    title: "Notificaciones",
    severity: "Severidad",
    showAll: "Mostrar todo",
    urgentSeverity: "Gravedad urgente",
    warningSeverity: "Gravedad de la advertencia",
    infoSeverity: "Gravedad de información",
    noNotificationsForSeverity:
      "No hay notificaciones para la gravedad seleccionada.",
    support: "Soporte",
    idPrefix: "ID",
  },
};

export const alarmsNotificationsDrawerModalNl = {
  [pageNameKey]: {
    idPrefix: "ID",
    infoSeverity: "Informatief ernstniveau",
    noNotificationsForSeverity:
      "Geen meldingen voor het geselecteerde ernstniveau.",
    severity: "Ernstniveau",
    showAll: "Alles weergeven",
    support: "Ondersteuning",
    title: "Meldingen",
    urgentSeverity: "Kritiek ernstniveau",
    warningSeverity: "Waarschuwingsniveau",
  },
};

export const alarmsNotificationsDrawerModalTr = {
  [pageNameKey]: {
    idPrefix: "İD",
    infoSeverity: "Bilgi Önem Derecesi",
    noNotificationsForSeverity: "Seçilen önem derecesi için bildirim yok.",
    severity: "Şiddet",
    showAll: "Tümünü göster",
    support: "Destek",
    title: "Bildirimler",
    urgentSeverity: "Acil Şiddet",
    warningSeverity: "Uyarı Önem Derecesi",
  },
};
